<template>
  <div class="list-container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="page-title">顧客予定表未作成一覧</h1>
      <div>
        <router-link :to="{ name: 'CustomerCalendarList' }"> <!-- 未請求作業一覧へのリンク -->
          <button type="button" class="btn btn-primary mx-1">顧客予定表一覧へ</button>
        </router-link>
        <router-link :to="{ name: 'Home' }"> <!-- ホームへのリンク -->
          <button type="button" class="btn btn-primary mx-1">ホーム</button>
        </router-link>
      </div>
    </div>

    <!-- 検索バーの追加 -->
    <form class="search-container p-3 my-3" style="background-color: #f8f9fa;" @submit.prevent="searchNonMonthlyBillings"> <!-- 背景色を薄く設定 -->
      <div class="row g-3 align-items-center">
        <div class="d-flex align-items-center mb-2 me-2 flex-wrap">
          <div class="me-2">
            <label class="col-form-label">予定年月</label>
          </div>
          <div class="d-flex align-items-center me-3">
            <select id="searchYear" class="form-select" v-model="searchYear" placeholder="年で検索">
              <option value="" disabled selected>選択してください</option> <!-- placeholder -->
              <option v-for="year in years" :key="year" :value="year">{{ year }}年</option>
            </select>

            <select id="searchMonth" class="form-select ms-2" v-model="searchMonth" placeholder="月で検索">
              <option value="" disabled selected>選択してください</option> <!-- placeholder -->
              <option v-for="month in months" :key="month" :value="month">{{ month }}月</option>
            </select>
          </div>

          <!-- 顧客検索 -->
          <!-- <div class="d-flex align-items-center my-2 me-3">
            <div class="col-auto">
              <CustomerSelectBox
                v-model="searchCustomerName"
                :options="customers"
                placeholder="顧客名で検索"
                :formatter="c => c.customer_nm"
              />
            </div>
          </div> -->

          <div class="d-flex align-items-center my-2 me-3">
            <div class="col-auto">
              <input type="text" id="searchCustomerName" class="form-control" v-model="searchCustomerName" placeholder="顧客名で検索">
            </div>
          </div>

          <!-- 建物検索 -->
          <div class="d-flex align-items-center my-2 me-3">
            <div class="col-auto">
              <BuildingSelectBox
                v-model="searchBuildingName"
                :options="buildings"
                placeholder="建物名で検索"
                :formatter="b => b.building_nm"
              />
            </div>
          </div>

          <div class="me-3">
            <button type="submit" class="btn btn-primary mx-1">検索</button>
            <button type="button" class="btn btn-secondary mx-1" @click="searchResetNonMonthlyBillings">クリア</button>
          </div>
        </div>
      </div>
    </form>

    <button
      type="button"
      class="btn btn-primary my-2"
      @click="submitSelection"
      :disabled="selectedAnnualWorkIds?.length == 0"
    >
      顧客予定表作成
    </button>

    <!-- 横並びの枠組み -->
    <div class="d-flex gap-4 flex-wrap">
      <!-- 左側 年間予定作業テーブル -->
      <div class="flex-fill" style="width: 90%">
        <h4 class="mb-1">未請求の年間予定作業</h4>
        <span class="text-danger">※定額請求のものは合計金額が定額で表示されます</span>
        <div class="table-wrapper">
          <div class="table-wrapper">
            <table class="table table-bordered table-hover">
              <thead class="annual-work-table-header">
                <tr>
                  <th class="th-sticky sticky-left">
                    <label :for="`annual_work_check_all`" class="ECM_CheckboxInput-sm">
                      <input
                        type="checkbox"
                        :id="`annual_work_check_all`"
                        :checked="selectedAnnualWorkIds.length === annualWorkBuildings.length"
                        class="ECM_CheckboxInput-Input-sm"
                        @click="toggleAnnualAllSelection"
                      />
                      <span class="ECM_CheckboxInput-DummyInput-sm"></span>
                    </label>
                  </th>
                  <th class="text-nowrap">建物名</th>
                  <th class="text-nowrap">建物種別</th>
                  <th class="text-nowrap">顧客名</th>
                  <th class="text-nowrap">定額請求</th>
                  <th class="text-nowrap">合計</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="annualWorkBuilding in annualWorkBuildings"
                  :key="annualWorkBuilding.id"
                  :class="{ 'selected-row': selectedAnnualWorkIds?.includes(annualWorkBuilding.id) }"
                  @click="toggleAnnualSelection(annualWorkBuilding.id)"
                >
                  <td class="text-nowrap th-sticky sticky-left">
                    <label :for="`annual_work_check_${annualWorkBuilding.id}`" class="ECM_CheckboxInput-sm">
                      <input
                        type="checkbox"
                        :value="annualWorkBuilding.id"
                        v-model="selectedAnnualWorkIds"
                        :id="`annual_work_check_${annualWorkBuilding.id}`"
                        class="ECM_CheckboxInput-Input-sm"
                        @click="toggleAnnualSelection(annualWorkBuilding.id)"
                      />
                      <span class="ECM_CheckboxInput-DummyInput-sm"></span>
                    </label>
                  </td>
                  <td class="text-nowrap text-start">{{ annualWorkBuilding.building_nm }}</td>
                  <td class="text-nowrap text-start">{{ annualWorkBuilding?.m_building_type?.building_type_nm }}</td>
                  <td class="multiline-text text-start">{{ annualWorkBuilding?.m_customer?.customer_nm }}</td>
                  <td class="text-nowrap text-start">
                    {{
                      {
                        true: "対象",
                        false: "",
                      }[annualWorkBuilding.fixed_fee_billing]
                    }}
                  </td>
                  <td class="text-nowrap text-end">{{ formatCurrency(annualWorkBuilding?.total_bill_amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getNonCreateCalendarWorkBuildings,
  getSelectBoxCustomers,
  getSelectBoxBuildings
 } from '@/api/axios';
// import CustomerSelectBox from '@/components/searchSelectBoxes/CustomerSelectBox.vue';
import BuildingSelectBox from '@/components/searchSelectBoxes/BuildingSelectBox.vue';

export default {
  components: {
    // CustomerSelectBox,
    BuildingSelectBox,
  },
  setup(_, { emit }) {
    const title = ref('月別未請求情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const router = useRouter();
    const route = useRoute();
    const customers = ref([]);
    const buildings = ref([]);
    const annualWorkBuildings = ref([]);
    const selectedAnnualWorkIds = ref([]);
    const years = ref([]);
    const months = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    const targetYear = ref('');
    const targetMonth = ref('');

    // 現在の年月を取得
    const currentDate = new Date()
    let nextYear = currentDate.getFullYear();
    let nextMonth = currentDate.getMonth() + 2; // 現在の月に1を加算（0-indexedなので+1が必要）

    if (nextMonth > 11) { // 月が12を超える場合
      nextMonth = 1; // 翌月は1月（0-indexed）
      nextYear += 1; // 年を繰り上げ
    }
    for (let i = nextYear - 5; i <= nextYear + 5; i++) {
      years.value.push(i);
    }

    targetYear.value = route.query.year ? parseInt(route.query.year, 10) : nextYear;
    targetMonth.value = route.query.month ? parseInt(route.query.month, 10) : nextMonth;

    // 検索用のデータプロパティ
    const searchYear = ref('');
    const searchMonth = ref('');
    const searchCustomerName = ref('');
    const searchBuildingName = ref('');
    const searchBillingDeadline = ref('');
    searchYear.value = targetYear.value;
    searchMonth.value = targetMonth.value;

    const fetchNonBillings = async () => {
      try {
        const response = await getNonCreateCalendarWorkBuildings({
          year: searchYear.value,
          month: searchMonth.value,
          customer_nm: searchCustomerName.value,
          building_id: searchBuildingName.value,
        });
        annualWorkBuildings.value = response.data.annual_works;
      } catch (error) {
        console.error('建物情報ーデータの取得に失敗しました:', error);
      }

      // 顧客情報（検索用）
      try {
        const response = await getSelectBoxCustomers();
        customers.value = response.data;
      } catch (error) {
        console.error('顧客情報ーデータの取得に失敗しました:', error);
      }

      // 建物情報（検索用）
      try {
        const response = await getSelectBoxBuildings();
        buildings.value = response.data;
      } catch (error) {
        console.error('建物情報ーデータの取得に失敗しました:', error);
      }
    };

    // 検索処理
    const searchNonMonthlyBillings = async () => {
      await fetchNonBillings();

      router.push({
        path: '/non-create-calendar-billings',
        query: {
          year: searchYear.value,
          month: searchMonth.value,
          customer_nm: searchCustomerName.value,
          building_id: searchBuildingName.value,
        },
      });
    };

    // リセット処理
    const searchResetNonMonthlyBillings = async () => {
      searchYear.value = '';
      searchMonth.value = '';
      searchCustomerName.value = '';
      searchBuildingName.value = '';

      await fetchNonBillings();

      router.replace({
        path: '/non-create-calendar-billings',
        query: {
          year: '',
          month: '',
          building_id: ''
        },
      });
    };

    // クエリパラメータの監視（画面遷移後の自動反映）
    watch(
      () => route.query,
      (newQuery) => {
        searchYear.value = newQuery.year || nextYear; // クエリがない場合は空にする
        searchMonth.value = newQuery.month || nextMonth; // クエリがない場合は空にする
        searchCustomerName.value = newQuery.customer_nm || ''; // クエリがない場合は空にする
        searchBuildingName.value = newQuery.building_id || ''; // クエリがない場合は空にする

        targetYear.value = searchYear.value;
        targetMonth.value = searchMonth.value;

        // データ再取得
        fetchNonBillings();
      },
      { immediate: true } // 初回に即座に実行
    );

    // 年間予定作業の全て選択
    const toggleAnnualAllSelection = () => {
      if (selectedAnnualWorkIds.value.length === annualWorkBuildings.value.length) {
        selectedAnnualWorkIds.value = [];
      } else {
        selectedAnnualWorkIds.value = annualWorkBuildings.value.map(b => b.id);
      }
    };

    // 年間予定作業の選択保持
    const toggleAnnualSelection = (workId) => {
      const index = selectedAnnualWorkIds.value.indexOf(workId);
      if (index === -1) {
        // 選択されていない場合は追加
        selectedAnnualWorkIds.value = [...selectedAnnualWorkIds.value, workId];
      } else {
        // 選択されている場合は削除
        selectedAnnualWorkIds.value = selectedAnnualWorkIds.value.filter(id => id !== workId);
      }
    };

    const submitSelection = () => {
      const selectedAnnualWorks = annualWorkBuildings.value.filter((work) =>
        selectedAnnualWorkIds.value?.includes(work.id)
      );

      console.log('選択された年間予定作業:', selectedAnnualWorks);

      emit('onSelect', {
        annual: selectedAnnualWorks
      });

      console.log(targetYear.value)
      console.log(targetMonth.value)

      router.replace({
        path: `/customer-calendar-create/${targetYear.value}/${targetMonth.value}`,
        query: {
          annual_work_ids: selectedAnnualWorkIds.value.map(String)
        },
      });
    };

    const formatYearMonthDay = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    };

    // Format currency
    const formatCurrency = (value) => {
      if (value) {
        return new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: 'JPY',
        }).format(value);
      }
      return '¥0';
    };

    onMounted(fetchNonBillings);

    return {
      title,
      customers,
      buildings,
      annualWorkBuildings,
      years,
      months,
      targetYear,
      targetMonth,
      fetchNonBillings,
      searchYear,
      searchMonth,
      searchCustomerName,
      searchBuildingName,
      searchBillingDeadline,
      searchNonMonthlyBillings,
      searchResetNonMonthlyBillings,
      toggleAnnualAllSelection,
      toggleAnnualSelection,
      selectedAnnualWorkIds,
      submitSelection,
      formatYearMonthDay,
      formatCurrency
    };
  }
};
</script>

<style scoped>
.building-item {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.building-item:hover {
  background-color: #f5f5f5;
}

.table-wrapper {
  background: #fff;
  border: 1px solid #BBBBBB;
  width: 100%;
  overflow-x: scroll;
}

.table-wrapper table{
  margin-bottom: 0;
}

.annual-work-table-header th {
  background: #005e66 !important; /* 背景色を設定し、スクロール中に背景が透けるのを防ぐ */
  color: #fff !important;
}

table th,
table td{
  font-size: 14px;
}

.table-wrapper .sticky-left {
  position: sticky;
  z-index: 100;
  border-left: none;
  left: 0;
}
.table-wrapper .sticky-left:before,
.table-wrapper .sticky-left:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-right: 1px solid #DEE2E6;
  z-index: 99;
}
.table-wrapper .sticky-left:before,
.table-wrapper .sticky-left:after,
.table-wrapper .sticky-left {
  min-width: 64px;
  width: 64px;
  max-width: 64px;
}
.status-no-billing td {
  background-color: #FFD5EC !important;
  color: #ff0000;
}

.status-no-sending td {
  background-color: #FFDBC9 !important;
  color: #000;
}

.status-no-schedule td {
  background-color: #CCFFCC !important;
  color: #000;
}

.status-no-confirm td {
  background-color: #FFFFCC !important;
  color: #000;
}

.status-all-ok td {
  background-color: #E6FFE9 !important;
  color: #000;
}

.selected-row{
  cursor: pointer;
}

.selected-row td {
  background-color: #f0f8ff;
}
</style>
